// import package
import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SocketContext from '../Context/SocketContext';

// import action
import { getBankDetail, getUPIDetail, getQRDetail, getUserSetting, viewUserProfile, logout } from '../../actions/users';
import { getKycDetail } from '../../actions/userKyc';
import { getPriceConversion, getANNC, getCurrency } from '../../actions/commonAction';
import { getAssetData } from '../../actions/walletAction';
import { unReadNotice, FetchunReadNotice } from '../../actions/notificationAction';
import isEmpty from 'lib/isEmpty';

const HelperRoute = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const socketContext = useContext(SocketContext);
    // redux-state
    const { isAuth } = useSelector(state => state.auth);
    const currencyOption = useSelector(state => state.currency)

    // function
    useEffect(() => {
        if (isAuth) {
            getUserSetting(dispatch)
            getBankDetail(dispatch)
            getUPIDetail(dispatch)
            getQRDetail(dispatch)
            getAssetData(dispatch)
            viewUserProfile(dispatch)
            getPriceConversion(dispatch)
            getANNC(dispatch)
            unReadNotice(dispatch)
            getKycDetail(dispatch)
        }
    }, [isAuth])

    useEffect(() => {
        if (!(currencyOption && currencyOption.length > 0)) {
            getCurrency(dispatch);
        }

        socketContext.socket.on('notice', (result) => {
            FetchunReadNotice(dispatch, result)
        })

        socketContext.socket.on('FORCE_LOGOUT', (result) => {
            let token = localStorage.getItem('user_token');
            if(result && token != result){
                logout(history, dispatch)
            }
        })
    }, [])

    return <div />
}

export default HelperRoute;